import React, { useCallback, useEffect, useRef, useState } from "react";
import { fdcRequest } from "./fdcApi";
import { staffSocket } from "./fdcSocket";
export default function useFDCData(staffId, path, initialValue = []) {
  const [data, setData] = useState(initialValue), [loading, setLoading] = useState(false), [error, setError] = useState("");
  const controllerRef = useRef(null);
  const load = useCallback(async () => {
    if (!staffId) return;
    controllerRef.current?.abort(); const controller = new AbortController(); controllerRef.current = controller;
    setLoading(true); setError("");
    try { const response = await fdcRequest(staffId, path, "get", undefined, { signal: controller.signal }); if (!controller.signal.aborted) setData(response.data); return response; }
    catch (e) { if (!controller.signal.aborted) setError(e.response?.data?.message || e.message); }
    finally { if (!controller.signal.aborted) setLoading(false); }
  }, [staffId, path]);
  useEffect(() => { load(); return () => controllerRef.current?.abort(); }, [load]);
  useEffect(() => {
    let timer;
    const refresh = () => { clearTimeout(timer);timer=setTimeout(load,150); };
    staffSocket.on("staff:updated", refresh); staffSocket.on("staff:notification", refresh); staffSocket.on("staff:message", refresh); staffSocket.on("connect", refresh);
    return () => { clearTimeout(timer);["staff:updated", "staff:notification", "staff:message", "connect"].forEach(event => staffSocket.off(event, refresh)); };
  }, [load]);
  return { data, setData, loading, error, setError, reload: load };
}
export function FDCDataState({ loading, error, reload }) {
  return <>{loading && <div className="fdcApiState" role="status">Loading account records…</div>}{error && <div className="fdcApiState error" role="alert"><span>{error}</span><button type="button" onClick={reload}>Retry</button></div>}</>;
}
